<template>
    <div class="admin-employees-page">
        <button-component @click.native="syncZorgProfessionals" :submitted="synchronizing">
            Synchronizeer Zorg Professionals
        </button-component>
        <p v-if="synchronizing">Synchroniseren...</p>
        <ul v-if="!synchronizing">
            <listitem-component
                    v-for="employee in getAllEmployees"
                    :key="employee.id"
                    @click.native="editEmployee(employee)">
                {{ employee.userName }}
            </listitem-component>
            <p v-if="getAllEmployees.length < 1">Er zijn nog geen Zorg Professionals toegevoegd</p>
        </ul>
    </div>
</template>

<script>
import { RouteName } from '../../utils/enums';
import ListitemComponent from '../../components/listitem.component';
import ButtonComponent from '../../components/button.component.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'admin-employees-page',
    components: {
        ListitemComponent,
        ButtonComponent
    },
    data() {
        return {
            synchronizing: false
        }
    },
    computed: {
        ...mapGetters(['getAllEmployees']),
    },
    created() {
        this.$store.dispatch('FETCH_ALL_LOCATIONS');
        this.$store.dispatch('FETCH_EMPLOYEES');
    },
    methods: {
        editEmployee(employee) {
            this.$store.commit('SET_EMPLOYEE_TO_EDIT', employee);
            this.$router.push({ name: RouteName.ADMIN_EDIT_EMPLOYEE });
        },
        syncZorgProfessionals() {
            this.synchronizing = true;
            this.$store.dispatch('SYNC_EMPLOYEES_WITH_AZURE_AD').then(res => {
                this.synchronizing = false
            });
        }
    }
};
</script>

<style scoped lang="scss">
    .listitem-component::v-deep {
        .listitem-icon {
            background-image: url('../../assets/icons/pofile-medium-white.svg');
            background-position-y: 12px;
        }
    }
</style>
